import { TOGGLE_MINI_CART } from './types';

export const toggleMiniCart = ({ open } = {}) => ({
  type: TOGGLE_MINI_CART,
  open,
});
